import React from "react";
import { RouteComponentProps } from "react-router";
import { Button, ToggleButtonGroup, ToggleButton, Dialog, WithTooltip, Tooltip, Icon } from "@abb/abb-common-ux-react";
import { v4 as uuidv4 } from "uuid";
import * as signalR from "@microsoft/signalr";
import Summary from "../shared/Summary";
import * as CONSTANTS from "../../utilities/Constants";
import SampleViewData, { defaultSampleData, ISampleViewData } from "../../models/sample/SampleViewData";
import "./sample.sass";
import { Translation } from "react-i18next";
import APIErrorCode from '../../utilities/ErrorCode.json';
import "../../utilities/Extensions";
import TabContent from "./TabContent";
import NameHeader from "../shared/NameHeader";
import { withRouter } from "react-router-dom";
import measurementActions from "../../flux/actions/MeasurementActions";
import MeasuredDetailsStore from "../../flux/stores/measurement/MeasuredDetailStore";
import triggerNotifications from '../../utilities/TriggerNotifications';
import MeasurementPauseStore from "../../flux/stores/measurement/MeasurementPauseStore";
import MeasurementStopStore from "../../flux/stores/measurement/MeasurementStopStore";
import IMeasuredDetails, { defaultMeasurementDetailsData } from "../../models/measurement/MeasuredDetails";
import { MEASUREMENT_HUB, MEASUREMENT_HUB_RECEIVE_MEASUREMENT, HUB_SETCONTEXT, MEASUREMENT_HUB_RECEIVE_MEASUREMENT_COUNT, INSTRUMENT_HUB, MEASUREMENT_HUB_RECEIVE_INSTRUMENT_STATUS, MEASUREMENT_HUB_RECEIVE_KEYEDIN, MEASUREMENT_HUB_RECEIVE_KEYEDIN_COUNT, STATUS_HUB, SAMPLE_HUB_RECEIVE_SAMPLE_STATUS, MEASUREMENT_HUB_RECEIVE_KEYEDIN_STATUS, CALCULATED_HUB, MEASUREMENT_HUB_RECEIVE_CALCULATED_PROPERTY, MEASUREMENT_HUB_AUTOLINE, EXCEPTION_HUB, HANDLE_EXCEPTION, MEASUREMENT_HUB_RECEIVE_AL_STATUS, MEASUREMENT_AL_HUB, RE_TRY_ATTEMPTS } from '../../utilities/HubConstants';
import KeyedInDetailsStore from "../../flux/stores/measurement/KeyedInDetailStore";
import keyedInCountStore from "../../flux/stores/measurement/KeyedInCountStore";
import { IInstrumentDetails, defaultInstrumentDetails, ICount, IValueRange, InstrumentDetails, IPositionMeans } from '../../models/measurement/InstrumentDetails';
import { IPositionCount } from "../../models/measurement/PositionCount";
import { IDirectionCount } from "../../models/measurement/DirectionCount";
import IColumnHeaderData from "../../models/shared/ColumnHeaderData";
import IKeyedInDetailsData, { defaultKeyedInDetailsData } from "../../models/measurement/KeyedInDetailsData";
import { defaultKeyedInDetails, IKeyedInDetails, KeyedInDetails } from '../../models/measurement/KeyedInDetails';
import { Status } from '../../models/sample/Status';
import History from "../../utilities/History";
import MeasurementRejectStore from "../../flux/stores/measurement/MeasurementRejectStore";
import MeasurementApproveStore from "../../flux/stores/measurement/MeasurementApproveStore";
import ICalculatedDetailsData, { defaultCalculatedDetailsData } from "../../models/measurement/CalculatedDetailsData";
import { ICalculatedDetails, defaultCalculatedDetails } from "../../models/measurement/CalculatedDetails";
import CalculatedDetailsStore from "../../flux/stores/measurement/CalculatedDetailStore";
import MeasurementDetailsStore from "../../flux/stores/measurement/MeasurementDetailsStore";
import SampleInstrumentDetailsStore from "../../flux/stores/measurement/SampleInstrumentDetailsStore";
import SelectedInstrumentSampleDetails from '../../flux/stores/measurement/SelectedInstrumentSampleDetails';
import MeasurementKeyedInStore from '../../flux/stores/measurement/MeasurementKeyedInStore';
import { defaultSampleKeyedInDetails, ISampleKeyedInDetails } from '../../models/measurement/SampleKeyedInDetails';
import { KeyedInDetailsData } from '../../models/measurement/KeyedInDetailsData';
import { IMeasurementProperties } from '../../models/measurement/InstrumentDetails';
import { SAMPLE_MEASUREMENT_PAUSE_MSG } from '../../utilities/Constants';
import { ABB_FULLSCREEN, ABB_MIDSCREEN } from "../../utilities/IconConstants";
import GraphTabItems from "./GraphTabItems";
import GraphTabContent from "./GraphTabContent";
import settingsActions from "../../flux/actions/SettingsAction";
import measurementSettingStore from "../../flux/stores/settings/MeasurementSettingStore";
import { defaultMeasurementSettingData, MeasurementSetting } from "../../models/settings/MeasurementSettings";
import IThresholdSettings from "../../models/settings/ThresholdSettings";
import thresholdSettingStore from "../../flux/stores/settings/ThresholdSettingStore";
import TabItems from "./TabItems";

type PropsType = RouteComponentProps & {
    isFullScreenVisible: boolean,
    activeTab: any,
    changeActiveTab: (e: any) => void,
    selectPage: number,
    changeSelectPage: (e: any) => void,
    changeFullScreen: () => void,
    location: any,
    startMeasurement: boolean,
    stopMeasurement: boolean,
    isPaused: boolean,
    measurementStateChangeHandler: (a: boolean, b: boolean, c: boolean) => void
};

interface ILandingState {
    sampleId: string;
    sampleData: SampleViewData;
    settings: MeasurementSetting;
    thresholdSettings: IThresholdSettings[];
    measurementDetails: IMeasuredDetails;
    keyedInDetailsData: IKeyedInDetailsData;
    keyedInSampleData: ISampleKeyedInDetails[];
    calculatedDetailsData: ICalculatedDetails[];
    directions: IDirectionCount[];
    positions: IPositionCount[];
    isMeasuredShow: boolean;
    isKeyedInShow: boolean;
    isCalculatedShow: boolean;
    activeTab: any[];
    selectInstrument: number;
    selectedKeyedIn: number;
    selectedCalculated: number;
    selectedInstrumentDetail: IInstrumentDetails;
    activeDirectionIndx: number;
    selectedKeyedInDetails: IKeyedInDetails;
    selectedCalculatedDetails: ICalculatedDetails;
    selectPage: number;
    showSummary: boolean;
    startMeasurement: boolean;
    stopMeasurement: boolean;
    disabledDetails: boolean;
    countValue: any;
    isComplete: boolean;
    isPaused: boolean;
    disableMeasured: boolean;
    disabledKeyedIn: boolean;
    disabledCalculated: boolean;
    sampleInstrumentDetails: any[];
    showStopDialog: boolean;
    showPauseDialog: boolean;
    stopLoading: boolean;
    pauseLoading: boolean;

    prevCount: number;
    prevValue: number;

    showRemeasureDialog: boolean;
    showInstrumentRemeasureDialog: boolean;
    showInstrumentStopDialog: boolean;
    isLoadingText: boolean;
}

interface IAppContextInterface {
    selectedKeyedInDetails: IKeyedInDetails;
    countValue: any;
    setOnchange: (e: any, count: number, propertyId: string, item: any) => void;
    onKeyedInCountSubmit: (data: any) => void
}

const ctxt = React.createContext<IAppContextInterface | null>(null);

export const AppContextProvider = ctxt.Provider;

export const AppContextConsumer = ctxt.Consumer;

class MeasurementLanding extends React.Component<PropsType, ILandingState> {

    private _mount: boolean = false;
    private _measurementDetails: IMeasuredDetails;
    private _keyedInDetails: any;
    private _keyedInCountDetails: any;
    private _calculatedDetails: ICalculatedDetails[];
    private _measurementConnection: signalR.HubConnection;
    private _instrumentConnection: signalR.HubConnection;
    private _sampleConnection: signalR.HubConnection;
    private _exceptionConnection: signalR.HubConnection;
    private _autolineConnection: signalR.HubConnection;
    private _stopMeasurement: boolean = false;
    _columns: IColumnHeaderData[];
    _isMeasurementRejected: boolean;
    _isMeasurementAproved: boolean = false;
    private _keyedInData: any[] = [];

    private _sampleInstrumentDetails: any;
    private _selectedInstrument: any;
    private _autolineProperties: IMeasurementProperties[] = [];
    private _selectedInstrumentId: any;
    private _selectedPosition: any = 0;
    private _currentMeasuringProperty: string;
    private _currentMeasuringPosition: number;
    private _instrumentSection: any;
    private _currentInstrumentId: any;
    private _settingsData: any;
    private _thresholdSettings: IThresholdSettings[];

    constructor(props: PropsType) {
        super(props);
        this._mount = true;
        this._instrumentSection = React.createRef()
        const sampleData = this.props.location.state?.sampleData as ISampleViewData;
        this.state = {
            sampleId: "",
            sampleData,
            settings: defaultMeasurementSettingData,
            thresholdSettings: [],
            measurementDetails: defaultMeasurementDetailsData,
            keyedInDetailsData: defaultKeyedInDetailsData,
            calculatedDetailsData: [],
            directions: [],
            isMeasuredShow: true,
            isKeyedInShow: true,
            isCalculatedShow: true,
            activeTab: this.props.activeTab ? this.props.activeTab : [0],
            selectInstrument: 0,
            selectedKeyedIn: 0,
            selectedCalculated: 0,
            selectedInstrumentDetail: defaultInstrumentDetails,
            activeDirectionIndx: 0,
            selectedKeyedInDetails: defaultKeyedInDetails,
            selectedCalculatedDetails: defaultCalculatedDetails,
            selectPage: this.props.selectPage ? this.props.selectPage : 2,
            positions: [],
            showSummary: false,
            startMeasurement: this.props.startMeasurement,
            stopMeasurement: this.props.stopMeasurement,
            disabledDetails: false,
            countValue: "",
            isComplete: false,
            isPaused: this.props.isPaused,
            disableMeasured: false,
            disabledKeyedIn: false,
            disabledCalculated: false,
            sampleInstrumentDetails: [],
            keyedInSampleData: [],
            showStopDialog: false,
            showPauseDialog: false,
            stopLoading: false,
            pauseLoading: false,

            prevCount: 0,
            prevValue: 0,

            showRemeasureDialog: false,
            showInstrumentRemeasureDialog: false,
            showInstrumentStopDialog: false,
            isLoadingText: false
        };
    }

    componentWillUnmount() {
        this._mount = false;
  
        this._measurementConnection.stop().then(() => { console.log("Measurement Hub Stopped") })
        this._instrumentConnection.stop().then(() => { console.log("Instrument Hub Stopped") });
        this._sampleConnection.stop().then(() => { console.log("SAMPLE Hub Stopped") });
        this._exceptionConnection.stop().then(() => { console.log("EXECPTION Hub Stopped") });
        this._autolineConnection.stop().then(() => console.log("STOPPED AUTOLINE HUB"))
    }
    componentWillReceiveProps() {
        this._instrumentSection.current.scrollIntoView({
            block: "nearest",
            inline: "center",
            behavior: "smooth",
            alignToTop: false
        })
    }
    componentDidUpdate(prevProps: any) {
        if (prevProps.location.key !== this.props.location.key) {
            const sampleData = this.props.location.state?.sampleData as ISampleViewData;
            if (sampleData !== undefined) {
                this._instrumentSection.current.scrollIntoView({
                    block: "nearest",
                    inline: "center",
                    behavior: "smooth",
                    alignToTop: false
                })
                if (this.state.sampleData.id !== sampleData.id) {
                    this._measurementConnection.stop().then(() => console.log("STOPPED FROM DIDMOUNT")).catch(() => { console.log("Measurement Hub Stopped") })
                    this.setState({
                        sampleData,
                        selectInstrument: 0,
                        stopMeasurement: false,
                        startMeasurement: false,
                        isComplete: false,
                        disableMeasured: false,
                        disabledKeyedIn: false,
                        disabledCalculated: false,
                        selectPage: 2
                    }, () => {
                        this.getInitialData(true, true);
                        const statusName = this.state.sampleData.status.name;
                        if (statusName === Status.MEASURING) {
                            this.props.changeSelectPage(2);
                            this.props.changeActiveTab([0]);
                            this.setState({
                                selectPage: 2,
                                activeTab: [0],
                                stopMeasurement: false,
                                startMeasurement: true,
                                isComplete: true,
                                isPaused: false
                            });
                        } else if (statusName === Status.MEASURED) {
                            this.setState({
                                stopMeasurement: true,
                                startMeasurement: false,
                                isComplete: true,
                                isPaused: false
                            });
                        } else if (statusName === Status.STOPPED) {
                            this.setState({
                                stopMeasurement: true,
                                startMeasurement: false,
                                isPaused: false
                            });
                        } else if (statusName === Status.PAUSED) {
                            this.setState({
                                stopMeasurement: false,
                                startMeasurement: false,
                                isPaused: true
                            });
                        }
                    })
                }
            }
        }
    }

    private getGeneralSettings = () => {
        settingsActions.getGeneral().then(() => {
            this.setState({
                settings: this._settingsData
            })
        }).catch((e: any) => {
            triggerNotifications.error(e);
        })
    }

    private getThresholdValues = () => {
        settingsActions.getThresholdReport().then(() => {
            this.setState({
                thresholdSettings: this._thresholdSettings
            })
        }).catch((e) => {
            triggerNotifications.error(e);
        })
    }

    componentDidMount() {
        this._mount = true;
        this._instrumentSection.current.scrollIntoView({
            block: "nearest",
            inline: "center",
            behavior: "smooth",
            alignToTop: false
        })

        Object.defineProperty(WebSocket, 'OPEN', {
            value: 1,
        });

        KeyedInDetailsStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
            this._keyedInDetails = state.data;
        });
        keyedInCountStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
            this._keyedInCountDetails = state.data;
        });
        CalculatedDetailsStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
            this._calculatedDetails = state.data;
        });
        MeasurementPauseStore.on(CONSTANTS.CHANGE_EVENT, state => {
            if (this._mount) {
                const data = state.data;
            }
        });

        MeasurementStopStore.on(CONSTANTS.CHANGE_EVENT, state => {
            
            if (this._mount) {
                this._stopMeasurement = true;
            }
        });
        MeasurementDetailsStore.on(CONSTANTS.CHANGE_EVENT, state => {
            if (this._mount) {
                this._measurementDetails = state.data;
            }
        });

        SampleInstrumentDetailsStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
            if (this._mount) {
                this._sampleInstrumentDetails = state.data
            }
        });

        SelectedInstrumentSampleDetails.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
            if (this._mount) {
                this._selectedInstrument = state.data;
            }
        });

        measurementSettingStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
            if (this._mount) {
                this._settingsData = state.data
            }
        });

        thresholdSettingStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
            if (this._mount) {
                this._thresholdSettings = state.data
            }
        });

        this.getGeneralSettings();
        this.getThresholdValues();

   
        // SET Measurement Connection HUB
        this._measurementConnection = new signalR.HubConnectionBuilder()
            .withUrl(MEASUREMENT_HUB)
            .withAutomaticReconnect(RE_TRY_ATTEMPTS)
            .build();

        // SET INSTRUMENT CONNECTION HUB
        this._instrumentConnection = new signalR.HubConnectionBuilder()
            .withUrl(INSTRUMENT_HUB)
            .withAutomaticReconnect(RE_TRY_ATTEMPTS)
            .build();

        this._sampleConnection = new signalR.HubConnectionBuilder()
            .withUrl(STATUS_HUB)
            .withAutomaticReconnect(RE_TRY_ATTEMPTS)
            .build();

        this._exceptionConnection = new signalR.HubConnectionBuilder()
            .withUrl(EXCEPTION_HUB)
            .withAutomaticReconnect(RE_TRY_ATTEMPTS)
            .build();

        this._autolineConnection = new signalR.HubConnectionBuilder()
            .withUrl(MEASUREMENT_AL_HUB)
            .withAutomaticReconnect(RE_TRY_ATTEMPTS)
            .build();

        this._exceptionConnection.on(HANDLE_EXCEPTION,
            (message: string) => {
           
                if (this._mount) {
                    if (message !== undefined) {
                        const messages = [];
                        const str = message.substring(1, message.length - 1)
                        const elm = str.split(':');
                        const eCode = APIErrorCode.ErrorCode.find(x => x["Message code "] === elm[0]);
                        if (eCode !== undefined) {
                            if (elm[1].length > 1) {
                                messages.push(eCode.Message);
                            } else if (elm[1].length > 2) {
                                const messageTwo = eCode.Message.format(elm[1][0], elm[1][1])
                                messages.push(messageTwo)
                            } else {
                                messages.push(eCode.Message)
                            }

                            triggerNotifications.errors(messages).then();
                        }
                    }
                }
            })


        this._sampleConnection.on(SAMPLE_HUB_RECEIVE_SAMPLE_STATUS,
            (sampleId: string, statusId: string, statusName: Status) => {
      
                if (this._mount) {
                    if (sampleId === this.state.sampleData.id) {
                        if (statusName === Status.MEASURED) {
                            this.setState({
                                stopMeasurement: true,
                                startMeasurement: false,
                                isComplete: true
                            });
                        } else if (statusName === Status.STOPPED) {
                            this.setState({
                                stopMeasurement: true,
                                startMeasurement: false,
                                isPaused: false
                            });
                        } else if (statusName === Status.PAUSED) {
                            this.setState({
                                stopMeasurement: false,
                                startMeasurement: false,
                                isPaused: true
                            });
                        }
                    }
                }
            });

        // START MEASUREMENT HUB BY DEFAULT
        this.measurementHubStart();
        this.sampleHubStart();
        this.exceptionHubStart();
        this.autolineHubStart();

        this._autolineConnection.on(MEASUREMENT_HUB_RECEIVE_AL_STATUS,
            (instrumentId: string, status: boolean) => {
        
                console.log("AUTOLINE HUB CONNECTION ", instrumentId, " --- ", status)
                if (status) {
                    const selectInstrument = this.state.measurementDetails.instrumentDetails.findIndex(x => x.id === instrumentId)
            
                    this.setState({
                        selectInstrument
                    }, () => this.getDefaultInstrumentdata(instrumentId));
                }
            });

        // On onreconnecting show the notification to user.
        this._measurementConnection.onreconnecting(() => {
            triggerNotifications.error(CONSTANTS.RE_CONNECTING)
        });

        // On Reconnected the Measurement Hub set the new context.
        this._measurementConnection.onreconnected(() => {
            this._measurementConnection.send(HUB_SETCONTEXT, this.state.sampleData.id).then().catch(err => console.log(err))
            triggerNotifications.success([CONSTANTS.RE_CONNECTED])
        });

        // RECEIVE MEASUREMENT DETAILS DATA FROM MEASUREMENT HUB
        this._measurementConnection.on(MEASUREMENT_HUB_RECEIVE_MEASUREMENT, (sampleId: string, measurementId: string,
            instrumentId: string, propertyId: string, directionId: string, position: number, currentCount: number,
            value: any, valueRange: any, statistics: any) => {
       
            console.log('RECEIVE MEASUREMENT DETAILS DATA FROM MEASUREMENT HUB :>> ', sampleId, measurementId,
                instrumentId, propertyId, directionId, position, currentCount,
                value, valueRange, statistics);
            if (this.state.measurementDetails.measurementId === measurementId && this.state.sampleData.id === sampleId) {
                const measurementDetails = { ...this.state.measurementDetails };
                const instrumentDetails = [...measurementDetails.instrumentDetails];
                const instrumentDetail = measurementDetails.instrumentDetails.find((x: any) => x.id === instrumentId);
                const instrumentDetailIndex = measurementDetails.instrumentDetails.findIndex((x: any) => x.id === instrumentId);
                const posMean = instrumentDetail.positionMeans.find(x => x.propertyId === propertyId);
                if (posMean) {
                    posMean.mean = statistics.mean;
                    posMean.position = position;
                }
                else {
                    instrumentDetail.positionMeans = [{ propertyId, position, mean: statistics.mean }] as IPositionMeans[];
                }
                const valueRangeData = { id: "", name: valueRange };
                instrumentDetail.setAverage(propertyId, directionId, position, statistics);
                const selectedProp = instrumentDetail?.properties.find(x => x.id === propertyId);
                instrumentDetail.setReadings(currentCount, directionId, position, propertyId, value, valueRangeData, "", selectedProp?.decimals);
                this._currentMeasuringProperty = propertyId;
                this._currentMeasuringPosition = position;
                instrumentDetail.currentMeasuringPosition = position;
                instrumentDetail.setCurrentMeasuringProperty(propertyId, position);
                instrumentDetails[instrumentDetailIndex] = instrumentDetail;
                this.setState({
                    measurementDetails: {
                        ...this.state.measurementDetails,
                        instrumentDetails
                    },
                });
            }
        });

        // RECEIVE COUNT DATA FROM MEASUREMENT HUB
        this._measurementConnection.on(MEASUREMENT_HUB_RECEIVE_MEASUREMENT_COUNT,
            (sampleId: any, measurementId: any, instrumentId: any, position: number, directionCount: any,
                positionCount: any, count: any) => {
                console.log('RECEIVE COUNT DATA FROM MEASUREMENT HUB :>> ', sampleId, measurementId, instrumentId, position,
                    directionCount,
                    positionCount, count);
          
                if (this.state.measurementDetails.measurementId === measurementId && this.state.sampleData.id === sampleId) {
                    const measurementDetails = { ...this.state.measurementDetails };
                    const instrumentDetails = [...measurementDetails.instrumentDetails];
                    const instrumentDetail = measurementDetails.instrumentDetails.find((x: any) => x.id === instrumentId);
                    const instrumentDetailIndex = measurementDetails.instrumentDetails.findIndex((x: any) => x.id === instrumentId);
                    this._selectedPosition = position;
                    if (this.state.selectInstrument != instrumentDetailIndex) {
                        this.onSelectTab(instrumentDetailIndex, instrumentId, false);
                    }
                    let activeDirectionIndex = this.state.activeDirectionIndx;
                    instrumentDetail.updateDirectionCount(position, directionCount.directionId, directionCount.completedCounts);
                    instrumentDetail.setCount(count);

                    instrumentDetail.setMeasuredPosition(position);
                    instrumentDetail.setCurrentMeasuringProperty(this._currentMeasuringProperty, this._currentMeasuringPosition);
                    let updatdPosCont = instrumentDetail.positionCount.findIndex(x => x.position === positionCount.position);
                    instrumentDetail.positionCount[updatdPosCont].selected = true;
                    instrumentDetail.positionCount[updatdPosCont].completedCounts = positionCount.completedCounts;
                    instrumentDetail.positionCount[updatdPosCont].totalCounts = positionCount.totalCounts;
                    instrumentDetail.setPositionCount(instrumentDetail.positionCount);
                    instrumentDetail.setCount(count);
                    instrumentDetail.setDirectionCount(position, directionCount.directionId, directionCount.completedCounts);
                    instrumentDetails[instrumentDetailIndex] = instrumentDetail;

                    const allDirectionsObj: any = {};
                    instrumentDetail.allDirections.forEach((alldir: any, i: number) => {
                        allDirectionsObj[alldir.name] = alldir;
                        if (this.state.sampleData?.testPlan?.isPDC) {
                            if (directionCount.directionId === alldir.id) {
                                if (directionCount.completedCounts === directionCount.totalCounts) {
                                    activeDirectionIndex = activeDirectionIndex + 1;
                                    if (instrumentDetail?.countData[position]?.directions[0]?.totalCounts === instrumentDetail?.countData[position]?.directions[0]?.completedCounts
                                        && positionCount.position !== instrumentDetail?.countData.length - 1) {
                                        ++position;
                                        instrumentDetail?.countData.forEach(element => {
                                            element.selected = false;
                                        });
                                        positionCount.position = position;
                                        instrumentDetail.countData[position].selected = true;
                                        instrumentDetail.setPositionVal = position;
                                        instrumentDetail.setMeasuredPosition(position);
                                        activeDirectionIndex = 0;
                                        this.onMeasuredPositionChange(position);
                                    }
                                }
                                else {
                                    activeDirectionIndex = i;
                                }
                            }
                        }
                        else {
                            if (directionCount.directionId === alldir.id) {
                                if (directionCount.completedCounts === directionCount.totalCounts) {
                                    activeDirectionIndex = activeDirectionIndex + 1;
                                    if (instrumentDetail?.countData[position]?.directions[activeDirectionIndex]?.maxCount === instrumentDetail?.countData[position]?.directions[activeDirectionIndex]?.completedCounts
                                        && positionCount.position !== instrumentDetail?.countData.length - 1) {
                                        ++position;
                                        instrumentDetail?.countData.forEach(element => {
                                            element.selected = false;
                                        });
                                        positionCount.position = position;
                                        instrumentDetail.countData[position].selected = true;
                                        instrumentDetail.setPositionVal = position;
                                        instrumentDetail.setMeasuredPosition(position);
                                        activeDirectionIndex = i;
                                        this.onMeasuredPositionChange(position);
                                    }
                                    else if (positionCount.position === instrumentDetail?.countData.length - 1) {
                                        position = 0;
                                        instrumentDetail?.countData.forEach(element => {
                                            element.selected = false;
                                        });
                                        positionCount.position = position;
                                        instrumentDetail.countData[position].selected = true;
                                        instrumentDetail.setPositionVal = position;
                                        instrumentDetail.setMeasuredPosition(position);
                                        this.onMeasuredPositionChange(position);
                                    }
                                }
                                else {
                                    activeDirectionIndex = i;
                                }
                            }
                        }
                    });
                    this.setState({
                        selectedInstrumentDetail: instrumentDetail,
                        activeDirectionIndx: activeDirectionIndex,
                        measurementDetails: {
                            ...this.state.measurementDetails,
                            instrumentDetails
                        }
                    });
                }
            });

        // INSTRUMENT (MEASURED PROPERTY) STATUS HUB
        this._instrumentConnection.on(MEASUREMENT_HUB_RECEIVE_INSTRUMENT_STATUS, (instrumentId: string,
            statusId: string, statusName: string) => {
        
            console.log('INSTRUMENT (MEASURED PROPERTY) STATUS HUB :>> ', instrumentId,
                statusId, statusName);
        
            const measurementDetails = { ...this.state.measurementDetails };
            const instrumentDetails = [...measurementDetails.instrumentDetails];
            const instrumentDetail = measurementDetails.instrumentDetails.find((x: any) => x.id === instrumentId);
            const instrumentDetailIndex = measurementDetails.instrumentDetails.findIndex((x: any) => x.id === instrumentId);

            instrumentDetail.setStatus({ id: instrumentId, name: statusName });
            instrumentDetails[instrumentDetailIndex] = instrumentDetail;

            this.setState({
                activeDirectionIndx: 0,
                measurementDetails: {
                    ...this.state.measurementDetails,
                    instrumentDetails
                }
            });
        });

        // Calculated Receive data from hub
        this._measurementConnection.on(MEASUREMENT_HUB_RECEIVE_CALCULATED_PROPERTY,
            (sampleId: string, measurementId: string,
                propertyId: string, value: number, valueRange: string, position: number, count: number) => {
                console.log('Calculated Receive data from hub :>> ', sampleId, measurementId,
                    propertyId, value, valueRange, position, count);
          
                const calculatedDetailsData: ICalculatedDetails[] = [...this.state.calculatedDetailsData];
                const calculatedDetail = calculatedDetailsData.find(x => x.id === propertyId);
                const calculatedDetailIndex = calculatedDetailsData.findIndex(x => x.id === propertyId)
                const calculatedValuesFind = calculatedDetail.calculatedValues.find(x => x.count === count);
                if (calculatedValuesFind !== undefined || calculatedValuesFind !== null) {
                    calculatedDetail.calculatedValues.push({ count, position, value, valueRange: { id: "", name: valueRange } })
                }
                calculatedDetailsData[calculatedDetailIndex] = calculatedDetail;
                this.setState({
                    calculatedDetailsData,
                    selectedCalculatedDetails: calculatedDetail
                });
            });

        this._measurementConnection.on(MEASUREMENT_HUB_RECEIVE_KEYEDIN,
            (sampleId: string, measurementId: string,
                propertyId: string, directionId: string, position: number, currentCount: number, value: number,
                valueRange: any, statistics: any
            ) => {
       
                console.log('RECEIVED KEYEDIN :>> ', sampleId, measurementId,
                    propertyId, directionId, position, currentCount, value,
                    statistics);
                if (this.state.keyedInDetailsData.measurementId === measurementId && this.state.sampleData.id === sampleId) {
                    const keyedInDetailsData = { ...this.state.keyedInDetailsData };
                    const keyedInDetails = [...keyedInDetailsData.keyedInDetails];
                    const keyedInDetail = keyedInDetailsData.keyedInDetails.find(x => x.id === propertyId);
                    const keyedInDetailIndex = keyedInDetailsData.keyedInDetails.findIndex(x => x.id === propertyId);

                    keyedInDetail.setAverage(propertyId, directionId, position, statistics);
                    keyedInDetails[keyedInDetailIndex] = keyedInDetail;
                    this.setState({
                        keyedInDetailsData: {
                            ...this.state.keyedInDetailsData,
                            keyedInDetails
                        }
                    });
                }
            });


        // KEYEDIN STATUS HUB
        this._measurementConnection.on(MEASUREMENT_HUB_RECEIVE_KEYEDIN_STATUS,
            (propertyId: string, statusId: string,
                statusName: string) => {
         
                console.log("KEYEDIN STATUS HUB :>> ", propertyId, " -- ", statusId, " -- ", statusName);
            }
        );

        // RECEIVE KEYEDIN COUNTS
        this._measurementConnection.on(MEASUREMENT_HUB_RECEIVE_KEYEDIN_COUNT,
            (sampleId: string, measurementId: string,
                propertyId: string, position: any, directionCount: any, positionCount: any, count: any) => {
                console.log('RECEIVE KEYEDIN COUNTS :>> ', propertyId, position, directionCount, positionCount,
                    count);
       
                if (this.state.keyedInDetailsData.measurementId === measurementId && this.state.sampleData.id === sampleId) {
                    const keyedInDetailsData = { ...this.state.keyedInDetailsData };
                    const keyedInDetails = [...keyedInDetailsData.keyedInDetails];
                    const keyedInDetail = keyedInDetailsData.keyedInDetails.find(x => x.id === propertyId);
                    const keyedInDetailIndex = keyedInDetailsData.keyedInDetails.findIndex(x => x.id === propertyId);
                    keyedInDetail.updateDirectionCount(position, directionCount.directionId, directionCount.completedCounts);
                    keyedInDetail.setCount([count]);
                    if (positionCount.totalCounts === positionCount.completedCounts) {
                        const totalPos = this.state.selectedKeyedInDetails.countData.length;
                        if (totalPos - 1 !== positionCount.position) {
                            keyedInDetail.setPositionValue(positionCount.position + 1);
                            this.onKeyedInPositionChange(positionCount.position + 1);
                        }
                    } else {
                        keyedInDetail.setPositionValue(positionCount.position)
                    }
                    keyedInDetails[keyedInDetailIndex] = keyedInDetail;
                    this.setState({
                        keyedInDetailsData: {
                            ...this.state.keyedInDetailsData,
                            keyedInDetails
                        }
                    });
                }
            });


        MeasurementRejectStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
            if (this._mount) {
                this._isMeasurementRejected = state.isMeasurementRejected
            }
        });

        MeasurementApproveStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
            if (this._mount) {
                this._isMeasurementAproved = state.isMeasurementAproved
            }
        });

        // get initial data from API
        this.getInitialData(true);

        // by default status of the sample if page refreshed
        if (this._mount) {
            if (this.state.sampleData.status.name === Status.MEASURED) {
                this.setState({
                    stopMeasurement: true,
                    startMeasurement: false,
                    isComplete: true
                });
            } else if (this.state.sampleData.status.name === Status.STOPPED) {
                this.setState({
                    stopMeasurement: true,
                    startMeasurement: false,
                    isPaused: false
                });
            } else if (this.state.sampleData.status.name === Status.PAUSED) {
                this.setState({
                    stopMeasurement: false,
                    startMeasurement: false,
                    isPaused: true
                });
            }
        }


        MeasurementKeyedInStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
            if (this._mount) {
                this._keyedInData = state.data;
            }
        });
    }

    private sampleHubStart = () => {
        this._sampleConnection.start().then(() => {
            this._sampleConnection.send(HUB_SETCONTEXT, this.state.sampleData.id).then().catch((error) => {
                console.log(error);
            });
        }).catch((err) => {
            console.log("ERRORHUB SAMPLE ", err);
            this._sampleConnection.stop().then(() => {
                this.sampleHubStart();
            })
        });
    }

    private exceptionHubStart = () => {
        this._exceptionConnection.start().then()
            .catch((err) => {
                console.log("ERRORHUB EXECPTION ", err)
                this._exceptionConnection.stop().then(() => {
                    this.exceptionHubStart();
                })
            });
    }

    private getInitialData(isConnection: boolean, fromUpdate?: boolean) {
        measurementActions.getSampleMeasurementDetails(this.state.sampleData.id).then(() => {
            this.setState({
                measurementDetails: this._measurementDetails
            }, () => {
                if (fromUpdate) {
                    this.measurementHubStart();
                }
                this.getMeasuredPropertyData(isConnection)
                this.getKeyedInPropertyData()
            });
        }).catch((err) => console.log('err', err));
        measurementActions.getSampleCalculatedDetails(this.state.sampleData.id, this.state.measurementDetails.measurementId).then(() => {
            if (this._mount) {
                if (this._calculatedDetails.length > 0) {
                    this.setState({
                        calculatedDetailsData: this._calculatedDetails
                    }, () => {

                        this.setState({
                            selectedCalculatedDetails: this.state.calculatedDetailsData[0]
                        });
                    });
                }
                else {
                    this.setState({
                        disabledCalculated: true
                    })
                }

            }
        });
    }

    private getMeasuredPropertyData = (isConnection: boolean) => {
        measurementActions.getInstrumentMeasurementDetails(this.state.measurementDetails.id, this.state.measurementDetails.measurementId)
            .then(() => {
                const instrumentDetails: IInstrumentDetails[] = [];
                this._sampleInstrumentDetails.map((data: any) => {
                    instrumentDetails.push(new InstrumentDetails(data.id, data.name,
                        data.count, [], [],
                        [], data.instrumentStatus, [],
                        [], [], [], data.isAutoLine))
                })
                if (this._sampleInstrumentDetails.length > 0) {
                    this.setState({
                        sampleInstrumentDetails: this._sampleInstrumentDetails,
                        measurementDetails: {
                            ...this.state.measurementDetails,
                            instrumentDetails
                        }
                    }, () => {
                        const selectedInstrument = this.state.sampleInstrumentDetails[0];
                        if (isConnection) {
                            const ids: any[] = [];
                            this.state.sampleInstrumentDetails.map((instrument) => {
                                ids.push(instrument.id)
                            });
              
                            this.instrumentHubStart(ids);
                        }

                        measurementActions.getInstrumentDetails(this.state.measurementDetails.id,
                            this.state.measurementDetails.measurementId, selectedInstrument.id)
                            .then(() => {
                                const selectedInstrumentDetail = new InstrumentDetails(this._selectedInstrument.id, this._selectedInstrument.name,
                                    selectedInstrument.count, this._selectedInstrument.directionCounts, this._selectedInstrument.properties,
                                    this._selectedInstrument.readings, selectedInstrument.instrumentStatus, this._selectedInstrument.positionCounts,
                                    this._selectedInstrument.statistics, this._selectedInstrument.propertyMeans, this._selectedInstrument.positionMeans,
                                    this._selectedInstrument.isAutoLine);

                                if (this._selectedInstrument.isAutoLine) {
            
                                    this._autolineProperties = this._selectedInstrument.properties;
                                    this._selectedInstrumentId = this._selectedInstrument.id;
                                }

                                const measurementDetails = { ...this.state.measurementDetails };
                                const instrumentDetails = [...measurementDetails.instrumentDetails];
                                const instrumentDetailIndex = measurementDetails.instrumentDetails.findIndex((x: any) => x.id === selectedInstrument.id);

                                instrumentDetails[instrumentDetailIndex] = selectedInstrumentDetail;
                                this.setState({
                                    selectInstrument: 0,
                                    selectedInstrumentDetail,
                                    measurementDetails: {
                                        ...this.state.measurementDetails,
                                        instrumentDetails
                                    }
                                });
                            })
                            .catch(errors => console.log('errors', errors))
                    })
                } else {
                    this.setState({
                        disableMeasured: true,
                        activeTab: [1]
                    })
                }
            }).catch((error) => console.log('error', error))

    }

    private getKeyedInPropertyData = () => {
        measurementActions.getSampleKeyedInDetails(this.state.sampleData.id,
            this.state.measurementDetails.measurementId).then(() => {
                if (this._mount) {
                    if (this._keyedInData.length > 0) {
                        this.setState({
                            keyedInSampleData: this._keyedInData
                        }, () => {
                            const selectedKeyedIn = this.state.keyedInSampleData[0];
                            measurementActions.getKeyedInDetails(this.state.measurementDetails.id,
                                this.state.measurementDetails.measurementId,
                                selectedKeyedIn.id).then(() => {
                                    const keyedInDetail: IKeyedInDetails[] = [];
                                    this.state.keyedInSampleData.map((selectedKeyedIn: any) => {
                                        keyedInDetail.push(new KeyedInDetails(selectedKeyedIn.id, selectedKeyedIn.name, [selectedKeyedIn.count],
                                            this._keyedInDetails.directionCounts, selectedKeyedIn.status, this._keyedInDetails.positionCounts,
                                            selectedKeyedIn.unit, this._keyedInDetails.readings, this._keyedInDetails.propertyMean, this._keyedInDetails.positionMeans, this._keyedInDetails.statistics,
                                            selectedKeyedIn.decimals)
                                        )
                                    })
                                    const keyedInDetailsList = [keyedInDetail];
                                    const keyedInDetailsData = new KeyedInDetailsData(selectedKeyedIn.id, selectedKeyedIn.name, "", true, this.state.measurementDetails.measurementId,
                                        "", "", keyedInDetail);
                                    this.setState({
                                        keyedInDetailsData
                                    }, () => {
                                        this.setState({
                                            selectedKeyedIn: 0,
                                            selectedKeyedInDetails: {
                                                ...this.state.keyedInDetailsData.keyedInDetails[0],
                                            }
                                        });
                                    });
                                }).catch(err => console.log(err))
                        });
                    }
                    else {
                        this.setState({
                            disabledKeyedIn: true
                        });
                    }
                }

            }).catch(error => console.log('error :>> ', error));
    }


    private measurementApprove = () => {
        measurementActions.approveSampleMeasurement(this.state.sampleData.id,
            this.state.keyedInDetailsData.measurementId, uuidv4()).then(
                res => {
                    if (this._isMeasurementAproved) {
                        triggerNotifications.success([CONSTANTS.SAMPLE_APPROVED_MESSAGE]);
                        setTimeout(() => {
                            History.push({
                                pathname: CONSTANTS.SAMPLE_INDEX_URL
                            })
                        }, CONSTANTS.NOTIFICATION_TIMEOUT);
                    }
                }
            ).catch((error) => {
                triggerNotifications.errors(error.message, error.data).then();
            })
    }

    private measurementReject = () => {
        measurementActions.rejectSampleMeasurement(this.state.sampleData.id,
            this.state.keyedInDetailsData.measurementId, uuidv4()).then(
                res => {
                    if (this._isMeasurementRejected) {
                        triggerNotifications.success([CONSTANTS.SAMPLE_REJECTED_MESSAGE]);
                        setTimeout(() => {
                            History.push({
                                pathname: CONSTANTS.SAMPLE_INDEX_URL
                            })
                        }, CONSTANTS.NOTIFICATION_TIMEOUT);
                    }
                }
            ).catch((error) => {
                triggerNotifications.errors(error.message, error.data).then();
            })
    }

    public onSelectTab = (index: number, id: string, iscallapi?: boolean) => {
        this.setState({
            selectInstrument: index,
        }, () => {
            this.getDefaultInstrumentdata(id)
            this._selectedPosition = 0;
        });
    }

    public onSelectKeyedInTab = (index: number, id: string) => {
        const selectedKeyedInDetails = this.state.keyedInDetailsData.keyedInDetails.find(x => x.id === id);
        this.setState({
            selectedKeyedIn: index
        }, () => {
            this.getSelectedKeyedInDetails(id)
        });
    }
    private getSelectedKeyedInDetails = (id: string) => {
        measurementActions.getSampleKeyedInDetails(this.state.sampleData.id,
            this.state.measurementDetails.measurementId).then(() => {
                if (this._mount) {
                    this.setState({
                        keyedInSampleData: this._keyedInData
                    }, () => {
                        if (this.state.keyedInSampleData.length > 0) {
                            const selectedKeyedIn = this.state.keyedInSampleData[0];
                            measurementActions.getKeyedInDetails(this.state.measurementDetails.id,
                                this.state.measurementDetails.measurementId,
                                id).then(() => {
                                    const keyedInDetail: IKeyedInDetails[] = [];
                                    this.state.keyedInSampleData.map((selectedKeyedIn: any) => {
                                        keyedInDetail.push(new KeyedInDetails(selectedKeyedIn.id, selectedKeyedIn.name, [selectedKeyedIn.count],
                                            this._keyedInDetails.directionCounts, selectedKeyedIn.status, this._keyedInDetails.positionCounts,
                                            selectedKeyedIn.unit, this._keyedInDetails.readings, this._keyedInDetails.propertyMean, this._keyedInDetails.positionMeans, this._keyedInDetails.statistics,
                                            selectedKeyedIn.decimals)
                                        )
                                    });

                                    const keyedInDetailsData = new KeyedInDetailsData(selectedKeyedIn.id, selectedKeyedIn.name, "", true, this.state.measurementDetails.measurementId,
                                        "", "", keyedInDetail);

                                    this.setState({
                                        keyedInDetailsData
                                    }, () => {
                                        const selectedKeyedInDetails = this.state.keyedInDetailsData.keyedInDetails.find(x => x.id === id)
                                        selectedKeyedInDetails.setPositionValue(0);
                                        this.setState({
                                            selectedKeyedInDetails
                                        });
                                    });
                                }).catch(err => console.log(err))
                        } else {
                            this.setState({
                                disabledKeyedIn: true
                            });
                        }

                    })
                }

            }).catch(error => console.log('error :>> ', error));

    }

    public onSelectCalculatedTab = (index: number, id: string) => {
        const selectedCalculatedDetails = this.state.calculatedDetailsData.find(x => x.id === id);
        this.setState({
            selectedCalculated: index,
            selectedCalculatedDetails
        });
    }

    private selectPage = (val: number) => {
        let activeTab = [0];
        if (this.state.disableMeasured) {
            activeTab = [1]
        } else if (this.state.disabledKeyedIn) {
            activeTab = [0]
        } else if (this.state.disableMeasured && this.state.disabledKeyedIn) {
            activeTab = [2]
        }
        this.props.changeSelectPage(val);
        this.setState({
            activeTab,
            selectPage: val,
            selectInstrument: 0,
            selectedKeyedIn: 0
        }, () => {
            if (this.state.selectPage === 1 || val === 2) {
                this.getInitialData(false);
            }
            if (this.state.selectPage === 3) {
                this.getInitialData(false);
            }
        })
    }

    private measurementStop = () => {
        this.setState({
            showStopDialog: true
        })
    }

    private onMeasurementStopOkClick = () => {
        const measurementId = this.state.measurementDetails.measurementId === null || this.state.measurementDetails.measurementId === undefined
            ? this.state.keyedInDetailsData.measurementId : this.state.measurementDetails.measurementId
        if (!this.state.stopLoading) {
            this.setState({
                stopLoading: true
            }, () => {
                measurementActions.stopMeasurement(this.state.sampleData.id, measurementId, uuidv4())
                    .then(() => {
                        this._measurementConnection.stop().then().catch(() => { console.log("Measurement Hub Stopped") })
                        this._instrumentConnection.stop().then().catch(() => { console.log("Instrument Hub Stopped") });
                        this.props.measurementStateChangeHandler(false, this._stopMeasurement, false);
                        this.setState({
                            showStopDialog: false,
                            stopMeasurement: this._stopMeasurement,
                            startMeasurement: false,
                            isPaused: false,
                            isComplete: false,
                            showSummary: true,
                            stopLoading: false
                        });
                        triggerNotifications.success([CONSTANTS.SAMPLE_STOPPED_MESSAGE]);
                    }).catch((error) => {
                        this.setState({
                            showStopDialog: false,
                            stopLoading: false
                        }, () => triggerNotifications.errors(error.message, error.data).then());
                    });
            })
        }
    }

    private measurementPause = () => {
        this.setState({
            showPauseDialog: true
        })
    }

    private onMeasurementPauseOkClick = () => {
        const measurementId = this.state.measurementDetails.measurementId === null || this.state.measurementDetails.measurementId === undefined
            ? this.state.keyedInDetailsData.measurementId : this.state.measurementDetails.measurementId;
        if (!this.state.pauseLoading) {
            this.setState({
                pauseLoading: true
            }, () => {
                measurementActions.pauseMeasurement(this.state.sampleData.id,
                    measurementId, uuidv4())
                    .then(() => {
                        this._measurementConnection.stop().then().catch(() => { console.log("Measurement Hub Stopped") })
                        this.props.measurementStateChangeHandler(false, false, true);
                        this.setState({
                            showPauseDialog: false,
                            isPaused: true,
                            stopMeasurement: false,
                            startMeasurement: false,
                            pauseLoading: false
                        }, () => triggerNotifications.success([CONSTANTS.SAMPLE_PAUSED_MESSAGE]))
                    }).catch((error) => {
                        this.setState({
                            showPauseDialog: false,
                            pauseLoading: false
                        }, () => triggerNotifications.errors(error.message, error.data).then())

                    });
            })
        }


    }

    private reMeasure = () => {
        this.setState({
            showRemeasureDialog: true
        })
    }

    private onRemeasureOkClick = () => {
        const measurementId = this.state.measurementDetails.measurementId === null || this.state.measurementDetails.measurementId === undefined
            ? this.state.keyedInDetailsData.measurementId : this.state.measurementDetails.measurementId;
        if (!this.state.pauseLoading) {
            this.setState({
                pauseLoading: true
            }, () => {
                measurementActions.reMeasureMeasurement(this.state.sampleData.id, measurementId).then(() => {
                    this.props.measurementStateChangeHandler(true, false, false);
                    this.setState({
                        startMeasurement: true,
                        stopMeasurement: false,
                        isPaused: false,
                        showRemeasureDialog: false,
                        pauseLoading: false
                    }, () => {
                        this.measurementHubStart();
                        this.getInitialData(true);
                    });
                }).catch((error: any) => {
                    this.setState({
                        showRemeasureDialog: false,
                        pauseLoading: false
                    }, () => triggerNotifications.errors(error.message, error.data).then());
                });
            })
        }
    }

    public completeMeasurement = () => {
        measurementActions.completeMeasurement(this.state.sampleData.id, this.state.sampleData.measurement || this.state.keyedInDetailsData.measurementId, uuidv4())
            .then(() => {
                History.push({
                    pathname: CONSTANTS.MEASUREMENT_OVERVIEW_URL,
                    state: {
                        sampleData: this.state.sampleData,
                        measurementId: this.state.keyedInDetailsData.measurementId,
                        isComplete: true
                    }
                })
            })
            .catch((error) => {
                triggerNotifications.errors(error.message, error.data).then();
            });
    }

    public resumeSampleMeasurement = () => {
        measurementActions.resumeMeasurement(this.state.sampleData.id,
            this.state.measurementDetails.measurementId, uuidv4())
            .then(() => {
                this.measurementHubStart();
                this.props.measurementStateChangeHandler(true, false, false);
                this.setState({
                    startMeasurement: true,
                    stopMeasurement: false,
                    isPaused: false
                });
            })
            .catch((error) => {
                triggerNotifications.errors(error.message, error.data).then();
            });
    }
    private onDirectionChangeHandler = (val: any, instrumentId: string, position: number) => {
        const measurementDetails = { ...this.state.measurementDetails };
        const instrumentDetails = [...measurementDetails.instrumentDetails];
        const selectedInstrument = instrumentDetails.find(x => x.id === instrumentId);
        const selectedInstrumentIndex = instrumentDetails.findIndex(x => x.id === instrumentId);
        selectedInstrument.setSelectedDirection(position, val);
        selectedInstrument.currentMeasuringPosition = position;
        instrumentDetails[selectedInstrumentIndex] = selectedInstrument;
        measurementDetails.instrumentDetails = instrumentDetails;
        this.setState({
            measurementDetails
        });
    }

    private onKeyedInDirectionHandler = (val: any, keyedInId: string, position: number) => {
        const keyedInDetailsData = { ...this.state.keyedInDetailsData };
        const keyedInDetails = [...keyedInDetailsData.keyedInDetails];
        const selectedKeyedIn = keyedInDetails.find(x => x.id === keyedInId);
        const selectedKeyedInIndex = keyedInDetails.findIndex(x => x.id === keyedInId);
        selectedKeyedIn.setSelectedDirection(position, val);
        keyedInDetails[selectedKeyedInIndex] = selectedKeyedIn;
        keyedInDetailsData.keyedInDetails = keyedInDetails;
        this.setState({
            keyedInDetailsData
        });
    }

    private autolineHubStart = () => {
        this._autolineConnection?.start().then().catch((error) => {
            console.log('ERROR AUTOLINE HUB  :>> ', error);
            this._autolineConnection.stop().then(() => {
                this.autolineHubStart()
            })
        });
    }

    private measurementHubStart = () => {
        this._measurementConnection?.start().then(() => {
            this._measurementConnection.send(HUB_SETCONTEXT, this.state.sampleData.id).then().catch(err => console.log(err));
        }).catch((error) => {
            console.log('ERROR HUB  :>> ', error);
            this._measurementConnection.stop().then(() => {
                this.measurementHubStart()
            })
        });
    }

    private instrumentHubStart = (ids: any) => {
        this._instrumentConnection?.start().then(() => {
            this._instrumentConnection.send(HUB_SETCONTEXT, ids)
                .then().catch(error => console.log(error));
        }).catch(err => {
            console.log('ERROR HUB  :>> ', err);
            this._instrumentConnection.stop().then(() => {
                this.instrumentHubStart(ids)
            });
        })
    }

    private measurementHubStop = () => {
        this._measurementConnection?.stop().then(() => {
        }).catch(() => {
            this.error("Measurement Hub Error Occured")
        })
    }

    private error = (message: string) => {
        triggerNotifications.error(message).then();
    }

    private onToggle(togglePosition: any[]) {
        this.props.changeActiveTab(togglePosition);
        this.setState({
            activeTab: togglePosition,
            selectedKeyedIn: 0
        }, () => this.state.activeTab.includes(0) ? this.getMeasuredPropertyData(false) : this.getKeyedInPropertyData());
    }


    public onShowSummary = () => {
        this.setState({
            showSummary: !this.state.showSummary
        })
    }

    public onChangeKeyedIn = (e: any, count: number, propertyId: string, item: any) => {
        e.preventDefault();
 
        let selectedKeyedInDetails = this.state.selectedKeyedInDetails;
        const selectedPosition = this.state.selectedKeyedInDetails.positionCounts.find(x => x.selected);
        const countData = this.state.selectedKeyedInDetails.countData.find(x => x.selected);
        const selectedDirection = countData.directions.find(x => x.selected);

        const keyedInDetails = this.state.keyedInDetailsData.keyedInDetails;
        const keyedInDetail = keyedInDetails.find(x => x.id === selectedKeyedInDetails.id);
        const keyedInDetailsIndex = keyedInDetails.findIndex(x => x.id === selectedKeyedInDetails.id);

        const reading = selectedKeyedInDetails.readings.find(x => x.directionId === selectedDirection.id
            && x.position === selectedPosition.position && x.propertyId === propertyId && x.count === count);

        let inputData = e.target.value ? e.target.value : "";
        inputData = inputData.replace(/,/g, '.'); // allow to enter , and replce it as dot.
        const val = /^\d*\.?\d*$/.test(inputData) ? inputData : "";

        if (reading === undefined || reading === null) {
            const data = {
                sampleId: this.state.sampleData.id,
                propertyId,
                measurementId: this.state.keyedInDetailsData.measurementId,
                position: selectedPosition.position,
                directionId: selectedDirection.id,
                count,
                value: val,
            }
            if (keyedInDetail.readings === undefined || keyedInDetail.readings == null) {
                keyedInDetail.readings = []
            }
            keyedInDetail.readings.push(data);
            keyedInDetails[keyedInDetailsIndex] = keyedInDetail;
            selectedKeyedInDetails = keyedInDetail;
            this.setState({
                keyedInDetailsData: {
                    ...this.state.keyedInDetailsData,
                    keyedInDetails
                },
                selectedKeyedInDetails,
                countValue: e.target.name,

                prevCount: count,
                prevValue: val,

            });
        } else {
            const readingIndex = selectedKeyedInDetails.readings.findIndex(x => x.directionId === keyedInDetail.id
                && x.position === selectedPosition.position && x.propertyId === propertyId && x.count === count);
            reading.value = val;
            keyedInDetail.readings[readingIndex] = reading;
            keyedInDetails[keyedInDetailsIndex] = keyedInDetail;
            selectedKeyedInDetails = keyedInDetail;
            this.setState({
                keyedInDetailsData: {
                    ...this.state.keyedInDetailsData,
                    keyedInDetails
                },
                selectedKeyedInDetails,
                countValue: e.target.name,

                prevCount: count,
                prevValue: val,
            });
        }
    }

    public onKeyedInCountSubmit = (data: any) => {

        if (!this.state.isLoadingText) {
            const noOfPosition = this.state.selectedKeyedInDetails.positionCounts.find(x => x.selected);
            if (data.e.keyCode === 13 || data.e.keyCode === 9) {
                const selectedPosition = this.state.selectedKeyedInDetails.positionCounts.find(x => x.selected);
                const countData = this.state.selectedKeyedInDetails.countData.find(x => x.selected);
                const selectedDirection = countData.directions.find(x => x.selected);
                const currentValue = data.value;
                if (data.e.keyCode === 9) {
                    if (data.count === noOfPosition.totalCounts) {
                        let position = selectedPosition.position + 1;
                        let focusInputIndex = data.propertyId + "_" + position + "_0";
                        this.setState({
                            countValue: focusInputIndex
                        });
                    } else {
                        let selectedCnt = data.count;
                        let focusInputIndex = data.propertyId + "_" + selectedPosition.position + "_" + selectedCnt;
                        this.setState({
                            countValue: focusInputIndex
                        });
                        data.count = this.state.prevCount;
                        data.value = this.state.prevValue;
                    }
                }

                if (data.e.keyCode === 13) {
                    let selectedCnt = data.count;
                    let focusInputIndex = data.propertyId + "_" + selectedPosition.position + "_" + selectedCnt;
                    this.setState({
                        countValue: focusInputIndex
                    });
                }

                if ((data.e.type === 'blur' || data.e.keyCode === 13) && data.count === noOfPosition.totalCounts) {
                    let position = selectedPosition.position + 1;
                    let focusInputIndex = data.propertyId + "_" + position + "_0";
                    this.setState({
                        countValue: focusInputIndex
                    });
                }

                const submitData = {
                    sampleId: this.state.sampleData.id,
                    propertyId: data.propertyId,
                    measurementId: this.state.keyedInDetailsData.measurementId,
                    position: selectedPosition.position,
                    directionId: selectedDirection.id,
                    count: data.count,
                    value: Number(data.value)
                }
                if (currentValue === "" || currentValue === null) {
                    triggerNotifications.error(CONSTANTS.KEYEDIN_VALUE_ERROR)
                } else {
                    this.setState({
                        isLoadingText: true
                    }, () => {
                        measurementActions.postCountData(submitData, uuidv4())
                            .then(() => {
                                const selectedKeyedInDetails = this.state.selectedKeyedInDetails;
                                const readings = selectedKeyedInDetails.readings.find(x =>
                                    x.sampleId === this.state.sampleData.id &&
                                    x.propertyId === data.propertyId
                                    && x.position === selectedPosition.position && x.directionId === selectedDirection.id
                                    && x.count === data.count);
                                readings.completed = true;
                                const keyedInDetails = this.state.keyedInDetailsData.keyedInDetails;
                                const keyedInDetail = keyedInDetails.find(x => x.id === selectedKeyedInDetails.id);
                                const reading = keyedInDetail.readings.find(x =>
                                    x.sampleId === this.state.sampleData.id &&
                                    x.propertyId === data.propertyId
                                    && x.position === selectedPosition.position && x.directionId === selectedDirection.id
                                    && x.count === data.count);
                                reading.completed = true;
                                const keyedInDetailsIndex = keyedInDetails.findIndex(x => x.id === selectedKeyedInDetails.id);
                                keyedInDetails[keyedInDetailsIndex] = keyedInDetail;

                                this.setState({
                                    isLoadingText: false,
                                    keyedInDetailsData: {
                                        ...this.state.keyedInDetailsData,
                                        keyedInDetails
                                    },
                                    selectedKeyedInDetails,
                                });
                            })
                            .catch((error) => {
                                this.setState({
                                    isLoadingText: false
                                })
                                triggerNotifications.errors(error.message, error.data).then();
                            })
                    })
                }

            }

        }
    }

    // instrument actions  
    private startInstrumentMeasurement = (instrumentId: string) => {

        measurementActions.startInstrumentMeasurement(this.state.sampleData.id,
            this.state.measurementDetails.measurementId,
            instrumentId, uuidv4())
            .then()
            .catch((error) => {
                triggerNotifications.errors(error.message, error.data).then();
            })
    }

    private stopInstrumentMeasurement = (instrumentId: string) => {
        this._currentInstrumentId = instrumentId;
        this.setState({
            showInstrumentStopDialog: true
        })
    }

    private stopAfterConfirm = () => {
        measurementActions.stopInstrumentMeasurement(this.state.sampleData.id,
            this.state.measurementDetails.measurementId,
            this._currentInstrumentId, uuidv4())
            .then(() => this.setState({
                showInstrumentStopDialog: false
            }))
            .catch((error) => {
                this.setState({
                    showInstrumentStopDialog: false
                }, () => triggerNotifications.errors(error.message, error.data).then());
            })
    }

    private resumeInstrumentMeasurement = (instrumentId: string) => {
        measurementActions.resumeInstrumentMeasurement(this.state.sampleData.id,
            this.state.measurementDetails.measurementId,
            instrumentId, uuidv4())
            .then()
            .catch((error) => {
                triggerNotifications.errors(error.message, error.data).then();
            })
    }

    private remeasureInstrumentMeasurement = (instrumentId: string) => {
        this._currentInstrumentId = instrumentId;
        this.setState({
            showInstrumentRemeasureDialog: true
        })
    }

    private remeasureAfterConfirmation = () => {
        measurementActions.remeasureInstrumentMeasurement(this.state.sampleData.id,
            this.state.measurementDetails.measurementId,
            this._currentInstrumentId, uuidv4())
            .then(() => {
                this.setState({
                    showInstrumentRemeasureDialog: false
                }, () => this.getDefaultInstrumentdata(this._currentInstrumentId))
            })
            .catch((error) => {
                this.setState({
                    showInstrumentRemeasureDialog: false
                }, () => triggerNotifications.errors(error.message, error.data).then());
            })
    }

    private getDefaultInstrumentdata = (instrumentId: string) => {
    
        measurementActions.getInstrumentMeasurementDetails(this.state.measurementDetails.id, this.state.measurementDetails.measurementId)
            .then(() => {
                const instrumentDetails: IInstrumentDetails[] = [];
                this._sampleInstrumentDetails.map((data: any) => {
                    instrumentDetails.push(new InstrumentDetails(data.id, data.name,
                        data.count, [], [],
                        [], data.instrumentStatus, [],
                        [], [], [], data.isAutoLine))
                })
                this.setState({
                    sampleInstrumentDetails: this._sampleInstrumentDetails,
                    measurementDetails: {
                        ...this.state.measurementDetails,
                        instrumentDetails
                    }
                }, () => {
                    const selectedInstrument = this.state.sampleInstrumentDetails.find(x => x.id === instrumentId);
                    measurementActions.getInstrumentDetails(this.state.measurementDetails.id,
                        this.state.measurementDetails.measurementId, instrumentId)
                        .then(() => {
                            const instrumentDetailIndex = this.state.measurementDetails.instrumentDetails.findIndex(x => x.id === selectedInstrument.id);
                            const selectedInstrumentDetail = new InstrumentDetails(this._selectedInstrument.id, this._selectedInstrument.name,
                                selectedInstrument.count, this._selectedInstrument.directionCounts, this._selectedInstrument.properties,
                                this._selectedInstrument.readings, selectedInstrument.instrumentStatus, this._selectedInstrument.positionCounts,
                                this._selectedInstrument.statistics, this._selectedInstrument.propertyMeans, this._selectedInstrument.positionMeans,
                                this._selectedInstrument.isAutoLine, this._selectedInstrument.measurementId);


                            const instrumentDetails = this.state.measurementDetails.instrumentDetails;
                            if (this._selectedPosition === undefined) {
                                selectedInstrumentDetail.setMeasuredPosition(0)
                            } else {
                                selectedInstrumentDetail.setMeasuredPosition(this._selectedPosition)
                            }
                            selectedInstrumentDetail.setCurrentMeasuringProperty(this._currentMeasuringProperty, this._currentMeasuringPosition);
                            instrumentDetails[instrumentDetailIndex] = selectedInstrumentDetail;
                            this.setState({
                                selectedInstrumentDetail,
                                measurementDetails: {
                                    ...this.state.measurementDetails,
                                    instrumentDetails
                                }
                            }, () => this.forceUpdate());
                        })
                        .catch(errors => console.log('errors', errors))
                })
            }).catch((error) => console.log('error', error))

    }

    // : MEASUREMENT POSITION CHANGE
    public onMeasuredPositionChange = (index: number) => {
        const measurementDetails = { ...this.state.measurementDetails };
        const instrumentDetails = [...measurementDetails.instrumentDetails];
        const selectedInstrument = instrumentDetails.find(x => x.id === this.state.selectedInstrumentDetail.id);
        const selectedInstrumentIndex = instrumentDetails.findIndex(x => x.id === this.state.selectedInstrumentDetail.id);
        selectedInstrument.setPosition(index);
        selectedInstrument.setMeasuredPosition(index);
        selectedInstrument.currentMeasuringPosition = index;
        instrumentDetails[selectedInstrumentIndex] = selectedInstrument;
        measurementDetails.instrumentDetails = instrumentDetails;
        this.setState({
            measurementDetails,
            selectedInstrumentDetail: selectedInstrument
        })
    }

    // : KEYEDIN POSITION CHANGE 
    public onKeyedInPositionChange = (index: number) => {
        const keyedInDetailsData = { ...this.state.keyedInDetailsData };
        const keyedInDetails = [...keyedInDetailsData.keyedInDetails];
        const selectedKeyedIn = keyedInDetails.find(x => x.id === this.state.selectedKeyedInDetails.id);
        const selectedKeyedInIndex = keyedInDetails.findIndex(x => x.id === this.state.selectedKeyedInDetails.id);
        selectedKeyedIn.setPosition(index);
        keyedInDetails[selectedKeyedInIndex] = selectedKeyedIn;
        keyedInDetailsData.keyedInDetails = keyedInDetails;
        this.setState({
            keyedInDetailsData,
            selectedKeyedInDetails: selectedKeyedIn
        });
    }

    private onSetActiveDirectionIndx = (index: any) => {
        this.setState({
            activeDirectionIndx: index
        })
    }
    public render() {
        return (
            <Translation>
                {t => (
                    <React.Fragment>
                        <div className="page-layout" >
                            <NameHeader authKey={CONSTANTS.AUTHKEY_SAMPLE_MODE} data={this.state.sampleData?.name}
                                measurementStatus={this.state.startMeasurement}
                                measurementStop={this.measurementStop}
                                measurementPause={this.measurementPause}
                                isPaused={this.state.isPaused}
                                resumeMeasurement={this.resumeSampleMeasurement}
                                stopMeasurement={this.state.stopMeasurement}
                                reMeasure={this.reMeasure}
                                measurementReject={this.measurementReject}
                                measurementApprove={this.measurementApprove}
                                completeMeasurement={this.completeMeasurement}
                            />
                            {!this.props.isFullScreenVisible &&
                                <div className="summary-layout">
                                    <Summary
                                        isToggle={true}
                                        isShow={this.state.showSummary} onToggleShow={this.onShowSummary}>
                                        <div className="page-scroll">
                                            <div className="row mt-1 ml-2">
                                                <div className="col-3">
                                                    <span className="summary-label">
                                                        {t(CONSTANTS.MODULE_SOURCE)}:
                                                    </span>
                                                    <span className="summary-value ml-2">
                                                        {this.state.sampleData?.source?.name}
                                                    </span>
                                                </div>
                                                <div className="col-3">
                                                    <span className="summary-label">
                                                        {t(CONSTANTS.MODULE_PRODUCT)}:
                                                    </span>
                                                    <span className="summary-value ml-2">
                                                        {this.state.sampleData?.product?.name}
                                                    </span>
                                                </div>
                                                <div className="col-3">
                                                    <span className="summary-label">
                                                        {t(CONSTANTS.MODULE_GRADE)}:
                                                    </span>
                                                    <span className="summary-value ml-2">
                                                        {this.state.sampleData?.product?.grade?.name}
                                                    </span>
                                                </div>
                                                <div className="col-3">
                                                    <span className="summary-label">{t(CONSTANTS.MODULE_TESTPLAN)}:{" "}
                                                    </span>
                                                    <span className="summary-value ml-2">
                                                        <WithTooltip>
                                                            <span className="text-ellipsis width-9rem">{this.state.sampleData?.testPlan?.name}</span>
                                                            <Tooltip className="nav-tooltip">
                                                                <p>{this.state.sampleData?.testPlan?.name}</p>
                                                            </Tooltip>
                                                        </WithTooltip>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-3">
                                                    <span className="summary-label">
                                                        {t(CONSTANTS.LABEL_SETID)}:
                                                    </span>
                                                    <span className="summary-value ml-2">
                                                        {this.state.sampleData?.setId}
                                                        {this.state?.sampleData?.setId}
                                                    </span>
                                                </div>
                                                <div className="col-3">
                                                    <span className="summary-label">
                                                        {t(CONSTANTS.LABEL_ORDERID)}:
                                                    </span>
                                                    <span className="summary-value ml-2">
                                                        {this.state.sampleData?.orderId}
                                                    </span>
                                                </div>
                                                <div className="col-3">
                                                    <span className="summary-label">
                                                        {t(CONSTANTS.LABEL_DATECREATED)}:</span>
                                                    <span className="summary-value ml-2">
                                                        {this.state.sampleData?.formatedDate}
                                                    </span>
                                                </div>
                                                <div className="col-md-3">
                                                    <span className="summary-label">
                                                        {t(CONSTANTS.LABEL_DATE_MODIFIED)}:
                                                    </span>
                                                    <span className="summary-value ml-2">
                                                        {this.state.sampleData?.updatedOn}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <span className="summary-label">
                                                    {t(CONSTANTS.LABEL_REMARKS)}:
                                                </span>
                                                <WithTooltip>
                                                    <div style={{ display: "inline-block", verticalAlign: "sub" }} className="summary-value ml-2 text-ellipsis width-8rem">
                                                        {this.state.sampleData?.description}
                                                    </div>
                                                    <Tooltip style={{ width: '200px' }}>
                                                        <p> {this.state.sampleData?.description}</p>
                                                    </Tooltip>
                                                </WithTooltip>
                                            </div>
                                        </div>
                                    </Summary>
                                </div>
                            }
                            <div className="test-overview summary" ref={this._instrumentSection}>
                                <div className="row height-40px">
                                    <div className="col-md-4 col-sm-4">
                                        <p className="sidebar-main-title font-weight-bold pt-2 ml-3">{t(CONSTANTS.TITLE_TESTOVERVIEW)}</p>
                                    </div>
                                    <div className="col-md-3 col-sm-3" style={{ "marginTop": "3px" }}>
                                        {(this.state.selectPage === 1) || (this.state.selectPage === 3) ? <ToggleButtonGroup
                                            className="text-center"
                                            selected={this.state.activeTab}
                                            // tslint:disable-next-line: jsx-no-lambda
                                            onChange={(v) => this.onToggle(v)}
                                            sizeClass="medium">
                                            <ToggleButton text={t(CONSTANTS.MEASURED)} disabled={this.state.disableMeasured} />
                                            <ToggleButton text={t(CONSTANTS.KEYED_IN)} disabled={this.state.disabledKeyedIn} />
                                            <ToggleButton text={t(CONSTANTS.CALCULATED)} disabled={this.state.disabledCalculated} />
                                        </ToggleButtonGroup> :
                                            <ToggleButtonGroup
                                                className="text-center"
                                                selected={this.state.activeTab}
                                                // tslint:disable-next-line: jsx-no-lambda
                                                onChange={(v) => this.onToggle(v)}
                                                sizeClass="medium">
                                                <ToggleButton text={t(CONSTANTS.MEASURED)} disabled={this.state.disableMeasured} />
                                                <ToggleButton text={t(CONSTANTS.KEYED_IN)} disabled={this.state.disabledKeyedIn} />

                                            </ToggleButtonGroup>
                                        }
                                    </div>

                                    <div className="col-md-5 col-sm-5 p-1">
                                        <div className="float-right sample-res-layout" style={{ marginRight: 23 }}>
                                            <Button type="discreet-blue"
                                                className={this.state.selectPage === 1 ? "selected-button" : ""}
                                                // tslint:disable-next-line: jsx-no-lambda
                                                onClick={() => this.selectPage(1)}
                                                icon="abb/dashboard" text={t(CONSTANTS.TITLE_TESTOVERVIEW_DASHBOARD)} />
                                            <Button type="discreet-blue"
                                                disabled={this.state.disabledDetails}
                                                className={this.state.selectPage === 2 ? "ml-2 selected-button" : "ml-2"}
                                                // tslint:disable-next-line: jsx-no-lambda
                                                onClick={() => this.selectPage(2)}
                                                icon="abb/search" text={t(CONSTANTS.TITLE_TESTOVERVIEW_DETAILS)} />
                                            <Button type="discreet-blue"
                                                disabled={this.state.disabledDetails}
                                                className={this.state.selectPage === 3 ? "ml-2 selected-button" : "ml-2"}
                                                // tslint:disable-next-line: jsx-no-lambda
                                                onClick={() => this.selectPage(3)}
                                                text={t(CONSTANTS.TITLE_TESTOVERVIEW_GRAPH)} />
                                            {!this.props.isFullScreenVisible &&
                                                <WithTooltip>
                                                    <Icon
                                                        name={ABB_FULLSCREEN}
                                                        sizeClass="medium"
                                                        className="icon-fullscreen cursor"
                                                        onClick={(e: any) => this.props.changeFullScreen()}
                                                    />
                                                    <Tooltip className="pl-2 pr-2 pb-1 nav-tooltip cursor">
                                                        <p>{t(CONSTANTS.FULL_SCREEN)}</p>
                                                    </Tooltip>
                                                </WithTooltip>
                                            }

                                            {this.props.isFullScreenVisible &&
                                                <WithTooltip>
                                                    <Icon
                                                        name={ABB_MIDSCREEN}
                                                        sizeClass="medium"
                                                        className="icon-fullscreen cursor"
                                                        onClick={(e: any) => this.props.changeFullScreen()}
                                                    />
                                                    <Tooltip className="nav-tooltip cursor">
                                                        <p>{t(CONSTANTS.EXIT_SCREEN)}​​​​​</p>
                                                    </Tooltip>
                                                </WithTooltip>
                                            }


                                        </div>
                                    </div>
                                </div>
                                <div className="hr-line" />
                                <div style={{ background: 'white' }}>
                                    <hr className="hr-line neg-margin-2x-t" />

                                    {/* MEASURED  */}
                                    <AppContextProvider value={{
                                        selectedKeyedInDetails: this.state.selectedKeyedInDetails,
                                        countValue: this.state.countValue,
                                        setOnchange: this.onChangeKeyedIn,
                                        onKeyedInCountSubmit: this.onKeyedInCountSubmit
                                    }}>
                                        {this.state.activeTab.includes(0) && <React.Fragment>
                                            {(this.state.selectPage === 1) &&
                                                <div className="pr-2 pb-2 pl-2 pt-0">
                                                    <TabItems
                                                        instrumentDetails={this.state.measurementDetails.instrumentDetails}
                                                        stopMeasurement={this.state.stopMeasurement}
                                                        pausedMeasurement={this.state.isPaused}
                                                        onSelectTab={this.onSelectTab}
                                                        onSelectKeyedInTab={this.onSelectKeyedInTab}
                                                        keyedInSection={false}
                                                        meauredSection={this.state.activeTab.includes(0)}
                                                        selectInstrument={this.state.selectInstrument}
                                                        keyedInDetails={this.state.keyedInDetailsData.keyedInDetails}
                                                        selectedKeyedIn={this.state.selectedKeyedIn}
                                                        startInstrumentMeasurement={this.startInstrumentMeasurement}
                                                        stopInstrumentMeasurement={this.stopInstrumentMeasurement}
                                                        resumeInstrumentMeasurement={this.resumeInstrumentMeasurement}
                                                        remeasureInstrumentMeasurement={this.remeasureInstrumentMeasurement}
                                                        isFullScreenVisible={this.props.isFullScreenVisible}
                                                    >
                                                        <div className="clearfix" />
                                                        <TabContent
                                                            details={false}
                                                            keyedInSection={false}
                                                            measuredSection={this.state.activeTab.includes(0)}
                                                            selectedInstrumentDetail={this.state.selectedInstrumentDetail}
                                                            activeDirectionIndx={this.state.activeDirectionIndx}
                                                            // tslint:disable-next-line: jsx-no-lambda
                                                            selectedKeyedInDetails={this.state.selectedKeyedInDetails}
                                                            onMeasuredPositionChange={this.onMeasuredPositionChange}
                                                            onKeyedInPositionChange={this.onKeyedInPositionChange}
                                                            isFullScreenVisible={this.props.isFullScreenVisible}
                                                            showSummary={this.state.showSummary}
                                                            thresholdSettings={this.state.thresholdSettings}
                                                            onSetActiveDirectionIndx={this.onSetActiveDirectionIndx}
                                                        />
                                                    </TabItems>
                                                </div>}
                                            {(this.state.selectPage === 2) && <div className="pr-2 pb-2 pl-2 pt-0">
                                                <TabItems
                                                    stopMeasurement={this.state.stopMeasurement}
                                                    pausedMeasurement={this.state.isPaused}
                                                    instrumentDetails={this.state.measurementDetails.instrumentDetails}
                                                    onSelectTab={this.onSelectTab}
                                                    onSelectKeyedInTab={this.onSelectKeyedInTab}
                                                    keyedInSection={false}
                                                    isFullScreenVisible={this.props.isFullScreenVisible}
                                                    meauredSection={this.state.activeTab.includes(0)}
                                                    selectInstrument={this.state.selectInstrument}
                                                    keyedInDetails={this.state.keyedInDetailsData.keyedInDetails}
                                                    selectedKeyedIn={this.state.selectedKeyedIn}
                                                    startInstrumentMeasurement={this.startInstrumentMeasurement}
                                                    stopInstrumentMeasurement={this.stopInstrumentMeasurement}
                                                    resumeInstrumentMeasurement={this.resumeInstrumentMeasurement}
                                                    remeasureInstrumentMeasurement={this.remeasureInstrumentMeasurement}
                                                >
                                                    <div className="clearfix" />
                                                    <TabContent details={true}
                                                        keyedInSection={false}
                                                        measuredSection={this.state.activeTab.includes(0)}
                                                        selectedInstrumentDetail={this.state.selectedInstrumentDetail}
                                                        activeDirectionIndx={this.state.activeDirectionIndx}
                                                        selectedKeyedInDetails={this.state.selectedKeyedInDetails}
                                                        onDirectionHandler={this.onDirectionChangeHandler}
                                                        onKeyedInDirectionHandler={this.onKeyedInDirectionHandler}
                                                        // tslint:disable-next-line: jsx-no-lambda
                                                        onMeasuredPositionChange={this.onMeasuredPositionChange}
                                                        onKeyedInPositionChange={this.onKeyedInPositionChange}
                                                        isFullScreenVisible={this.props.isFullScreenVisible}
                                                        showSummary={this.state.showSummary}
                                                        thresholdSettings={this.state.thresholdSettings}
                                                        onSetActiveDirectionIndx={this.onSetActiveDirectionIndx}
                                                    />
                                                </TabItems>
                                            </div>}
                                            {
                                                (this.state.selectPage === 3) &&
                                                <div className="pr-2 pb-2 pl-2 pt-0">
                                                    <GraphTabItems
                                                        instrumentDetails={this.state.measurementDetails.instrumentDetails}
                                                        stopMeasurement={this.state.stopMeasurement}
                                                        pausedMeasurement={this.state.isPaused}
                                                        onSelectTab={this.onSelectTab}
                                                        onSelectKeyedInTab={this.onSelectKeyedInTab}
                                                        keyedInSection={false}
                                                        meauredSection={this.state.activeTab.includes(0)}
                                                        selectInstrument={this.state.selectInstrument}
                                                        keyedInDetails={this.state.keyedInDetailsData.keyedInDetails}
                                                        selectedKeyedIn={this.state.selectedKeyedIn}
                                                        startInstrumentMeasurement={this.startInstrumentMeasurement}
                                                        stopInstrumentMeasurement={this.stopInstrumentMeasurement}
                                                        resumeInstrumentMeasurement={this.resumeInstrumentMeasurement}
                                                        remeasureInstrumentMeasurement={this.remeasureInstrumentMeasurement}
                                                        isFullScreenVisible={this.props.isFullScreenVisible}

                                                    >
                                                        <div className="clearfix" />
                                                        <GraphTabContent
                                                            details={false}
                                                            keyedInSection={false}
                                                            measuredSection={this.state.activeTab.includes(0)}
                                                            selectedInstrumentDetail={this.state.selectedInstrumentDetail}
                                                            activeDirectionIndx={this.state.activeDirectionIndx}
                                                            // tslint:disable-next-line: jsx-no-lambda
                                                            keyedInSampleData={this.state.keyedInSampleData}
                                                            selectedKeyedInDetails={this.state.selectedKeyedInDetails}
                                                            onMeasuredPositionChange={this.onMeasuredPositionChange}
                                                            onKeyedInPositionChange={this.onKeyedInPositionChange}
                                                            isFullScreenVisible={this.props.isFullScreenVisible}
                                                            showSummary={this.state.showSummary}
                                                            settings={this.state.settings}
                                                            thresholdSettings={this.state.thresholdSettings}
                                                        />
                                                    </GraphTabItems>
                                                </div>
                                            }
                                        </React.Fragment>}

                                        {/* KEYEDIN  */}

                                        {this.state.activeTab.includes(1) && <React.Fragment>
                                            {this.state.selectPage === 1 && <div className="pr-2 pb-2 pl-2 pt-0">
                                                <TabItems
                                                    keyedInSection={this.state.activeTab.includes(1)}
                                                    onSelectTab={this.onSelectTab}
                                                    onSelectKeyedInTab={this.onSelectKeyedInTab}
                                                    isFullScreenVisible={this.props.isFullScreenVisible}
                                                    keyedInDetails={this.state.keyedInDetailsData.keyedInDetails}
                                                    instrumentDetails={this.state.measurementDetails.instrumentDetails}
                                                    selectedKeyedIn={this.state.selectedKeyedIn}
                                                    selectInstrument={this.state.selectInstrument}
                                                    startInstrumentMeasurement={this.startInstrumentMeasurement}
                                                    stopInstrumentMeasurement={this.stopInstrumentMeasurement}
                                                    resumeInstrumentMeasurement={this.resumeInstrumentMeasurement}
                                                    remeasureInstrumentMeasurement={this.remeasureInstrumentMeasurement}
                                                >
                                                    <div className="clearfix" />
                                                    <TabContent
                                                        details={false}
                                                        keyedInSection={this.state.activeTab.includes(1)}
                                                        selectedInstrumentDetail={this.state.selectedInstrumentDetail}
                                                        activeDirectionIndx={this.state.activeDirectionIndx}
                                                        selectedKeyedInDetails={this.state.selectedKeyedInDetails}
                                                        // tslint:disable-next-line: jsx-no-lambda
                                                        onKeyedInPositionChange={this.onKeyedInPositionChange}
                                                        isLoadingText={this.state.isLoadingText}
                                                        isFullScreenVisible={this.props.isFullScreenVisible}
                                                        showSummary={this.state.showSummary}
                                                        thresholdSettings={this.state.thresholdSettings}
                                                        onSetActiveDirectionIndx={this.onSetActiveDirectionIndx}
                                                    />
                                                </TabItems>
                                            </div>
                                            }
                                            {this.state.selectPage === 2 && <div className="pr-2 pb-2 pl-2 pt-0">
                                                <TabItems
                                                    keyedInDetails={this.state.keyedInDetailsData.keyedInDetails}
                                                    selectedKeyedIn={this.state.selectedKeyedIn}
                                                    onSelectTab={this.onSelectTab}
                                                    onSelectKeyedInTab={this.onSelectKeyedInTab}
                                                    isFullScreenVisible={this.props.isFullScreenVisible}
                                                    keyedInSection={this.state.activeTab.includes(1)}
                                                    instrumentDetails={this.state.measurementDetails.instrumentDetails}
                                                    selectInstrument={this.state.selectInstrument}
                                                    startInstrumentMeasurement={this.startInstrumentMeasurement}
                                                    stopInstrumentMeasurement={this.stopInstrumentMeasurement}
                                                    resumeInstrumentMeasurement={this.resumeInstrumentMeasurement}
                                                    remeasureInstrumentMeasurement={this.remeasureInstrumentMeasurement}
                                                >
                                                    <div className="clearfix" />
                                                    <TabContent
                                                        details={true}
                                                        keyedInSection={this.state.activeTab.includes(1)}
                                                        selectedInstrumentDetail={this.state.selectedInstrumentDetail}
                                                        activeDirectionIndx={this.state.activeDirectionIndx}
                                                        selectedKeyedInDetails={this.state.selectedKeyedInDetails}
                                                        onDirectionHandler={this.onDirectionChangeHandler}
                                                        onKeyedInDirectionHandler={this.onKeyedInDirectionHandler}
                                                        // tslint:disable-next-line: jsx-no-lambda
                                                        onKeyedInPositionChange={this.onKeyedInPositionChange}
                                                        isLoadingText={this.state.isLoadingText}
                                                        isFullScreenVisible={this.props.isFullScreenVisible}
                                                        showSummary={this.state.showSummary}
                                                        thresholdSettings={this.state.thresholdSettings}
                                                        onSetActiveDirectionIndx={this.onSetActiveDirectionIndx}
                                                    />
                                                </TabItems>
                                            </div>}
                                            {this.state.selectPage === 3 && <div className="pr-2 pb-2 pl-2 pt-0">
                                                <GraphTabItems
                                                    keyedInSection={this.state.activeTab.includes(1)}
                                                    onSelectTab={this.onSelectTab}
                                                    onSelectKeyedInTab={this.onSelectKeyedInTab}
                                                    isFullScreenVisible={this.props.isFullScreenVisible}
                                                    keyedInDetails={this.state.keyedInDetailsData.keyedInDetails}
                                                    instrumentDetails={this.state.measurementDetails.instrumentDetails}
                                                    selectedKeyedIn={this.state.selectedKeyedIn}
                                                    selectInstrument={this.state.selectInstrument}
                                                    startInstrumentMeasurement={this.startInstrumentMeasurement}
                                                    stopInstrumentMeasurement={this.stopInstrumentMeasurement}
                                                    resumeInstrumentMeasurement={this.resumeInstrumentMeasurement}
                                                    remeasureInstrumentMeasurement={this.remeasureInstrumentMeasurement}

                                                >
                                                    <div className="clearfix" />
                                                    <GraphTabContent
                                                        details={false}
                                                        keyedInSection={this.state.activeTab.includes(1)}
                                                        selectedInstrumentDetail={this.state.selectedInstrumentDetail}
                                                        activeDirectionIndx={this.state.activeDirectionIndx}
                                                        keyedInSampleData={this.state.keyedInSampleData}
                                                        selectedKeyedInDetails={this.state.selectedKeyedInDetails}
                                                        // tslint:disable-next-line: jsx-no-lambda
                                                        onKeyedInPositionChange={this.onKeyedInPositionChange}
                                                        isLoadingText={this.state.isLoadingText}
                                                        isFullScreenVisible={this.props.isFullScreenVisible}
                                                        showSummary={this.state.showSummary}
                                                        settings={this.state.settings}
                                                        thresholdSettings={this.state.thresholdSettings}
                                                    />
                                                </GraphTabItems>
                                            </div>
                                            }
                                        </React.Fragment>}

                                        {/* CALCULATED  */}
                                        {this.state.activeTab.includes(2) && <React.Fragment>
                                            {this.state.selectPage === 2 && null}
                                            {this.state.selectPage === 1 && <div className="pr-2 pb-2 pl-2 pt-0">
                                                <TabItems
                                                    keyedInDetails={this.state.keyedInDetailsData.keyedInDetails}
                                                    selectedKeyedIn={this.state.selectedKeyedIn}
                                                    CalculatedDetails={this.state.calculatedDetailsData}
                                                    selectedCalculated={this.state.selectedCalculated}
                                                    onSelectTab={this.onSelectTab}
                                                    onSelectKeyedInTab={this.onSelectKeyedInTab}
                                                    isFullScreenVisible={this.props.isFullScreenVisible}
                                                    onSelectCalculatedTab={this.onSelectCalculatedTab}
                                                    calculatedSection={this.state.activeTab.includes(2)}
                                                    instrumentDetails={this.state.measurementDetails.instrumentDetails}
                                                    selectInstrument={this.state.selectInstrument}
                                                    startInstrumentMeasurement={this.startInstrumentMeasurement}
                                                    stopInstrumentMeasurement={this.stopInstrumentMeasurement}
                                                    resumeInstrumentMeasurement={this.resumeInstrumentMeasurement}
                                                    remeasureInstrumentMeasurement={this.remeasureInstrumentMeasurement}
                                                >
                                                    <div className="clearfix" />
                                                    <TabContent
                                                        details={false}
                                                        calculatedSection={this.state.activeTab.includes(2)}
                                                        selectedInstrumentDetail={this.state.selectedInstrumentDetail}
                                                        activeDirectionIndx={this.state.activeDirectionIndx}
                                                        selectedKeyedInDetails={this.state.selectedKeyedInDetails}
                                                        selectedCalculatedDetails={this.state.selectedCalculatedDetails}
                                                        onDirectionHandler={this.onDirectionChangeHandler}
                                                        onKeyedInDirectionHandler={this.onKeyedInDirectionHandler}
                                                        isFullScreenVisible={this.props.isFullScreenVisible}
                                                        showSummary={this.state.showSummary}
                                                        thresholdSettings={this.state.thresholdSettings}
                                                        onSetActiveDirectionIndx={this.onSetActiveDirectionIndx}
                                                    // tslint:disable-next-line: jsx-no-lambda
                                                    />
                                                </TabItems>
                                            </div>}
                                            {this.state.selectPage === 3 && <div className="pr-2 pb-2 pl-2 pt-0">
                                                <GraphTabItems
                                                    keyedInDetails={this.state.keyedInDetailsData.keyedInDetails}
                                                    selectedKeyedIn={this.state.selectedKeyedIn}
                                                    CalculatedDetails={this.state.calculatedDetailsData}
                                                    selectedCalculated={this.state.selectedCalculated}
                                                    onSelectTab={this.onSelectTab}
                                                    onSelectKeyedInTab={this.onSelectKeyedInTab}
                                                    isFullScreenVisible={this.props.isFullScreenVisible}
                                                    onSelectCalculatedTab={this.onSelectCalculatedTab}
                                                    calculatedSection={this.state.activeTab.includes(2)}
                                                    instrumentDetails={this.state.measurementDetails.instrumentDetails}
                                                    selectInstrument={this.state.selectInstrument}
                                                    startInstrumentMeasurement={this.startInstrumentMeasurement}
                                                    stopInstrumentMeasurement={this.stopInstrumentMeasurement}
                                                    resumeInstrumentMeasurement={this.resumeInstrumentMeasurement}
                                                    remeasureInstrumentMeasurement={this.remeasureInstrumentMeasurement}

                                                >
                                                    <div className="clearfix" />
                                                    <GraphTabContent
                                                        details={false}
                                                        calculatedSection={this.state.activeTab.includes(2)}
                                                        selectedInstrumentDetail={this.state.selectedInstrumentDetail}
                                                        activeDirectionIndx={this.state.activeDirectionIndx}
                                                        keyedInSampleData={this.state.keyedInSampleData}
                                                        selectedKeyedInDetails={this.state.selectedKeyedInDetails}
                                                        selectedCalculatedDetails={this.state.selectedCalculatedDetails}
                                                        onDirectionHandler={this.onDirectionChangeHandler}
                                                        onKeyedInDirectionHandler={this.onKeyedInDirectionHandler}
                                                        isFullScreenVisible={this.props.isFullScreenVisible}
                                                        showSummary={this.state.showSummary}
                                                        settings={this.state.settings}
                                                        thresholdSettings={this.state.thresholdSettings}
                                                    // tslint:disable-next-line: jsx-no-lambda
                                                    />
                                                </GraphTabItems>
                                            </div>}
                                        </React.Fragment>}
                                    </AppContextProvider>
                                </div>
                            </div>

                            <Dialog isOpen={this.state.showStopDialog}
                                // tslint:disable-next-line: jsx-no-lambda
                                onClose={() => this.setState({ showStopDialog: false })}
                                showCloseButton={true}
                                closeOnEscape={false}
                                closeOnLostFocus={false}
                                dimBackground={true}
                                title={t(CONSTANTS.SAMPLE_MEASUREMENT_STOPPED_MSG)}
                                standardButtonsOnBottom={[
                                    { text: t(CONSTANTS.BUTTON_CANCEL), type: 'discreet-blue', handler: dlg => dlg.close() },
                                    { text: t(CONSTANTS.BUTTON_OK), type: 'primary-blue', handler: this.onMeasurementStopOkClick }
                                ]} />


                            <Dialog isOpen={this.state.showPauseDialog}
                                // tslint:disable-next-line: jsx-no-lambda
                                onClose={() => this.setState({ showPauseDialog: false })}
                                showCloseButton={true}
                                closeOnEscape={false}
                                closeOnLostFocus={false}
                                dimBackground={true}
                                title={t(CONSTANTS.SAMPLE_MEASUREMENT_PAUSE_MSG)}
                                standardButtonsOnBottom={[
                                    { text: t(CONSTANTS.BUTTON_CANCEL), type: 'discreet-blue', handler: dlg => dlg.close() },
                                    { text: t(CONSTANTS.BUTTON_OK), type: 'primary-blue', handler: this.onMeasurementPauseOkClick }
                                ]} />

                            <Dialog isOpen={this.state.showRemeasureDialog}
                                // tslint:disable-next-line: jsx-no-lambda
                                onClose={() => this.setState({ showRemeasureDialog: false })}
                                showCloseButton={true}
                                closeOnEscape={false}
                                closeOnLostFocus={false}
                                dimBackground={true}
                                title={t(CONSTANTS.SAMPLE_MEASUREMENT_REMEASURE_MSG)}
                                standardButtonsOnBottom={[
                                    { text: t(CONSTANTS.BUTTON_CANCEL), type: 'discreet-blue', handler: dlg => dlg.close() },
                                    { text: t(CONSTANTS.BUTTON_OK), type: 'primary-blue', handler: this.onRemeasureOkClick }
                                ]} />

                            <Dialog isOpen={this.state.showInstrumentRemeasureDialog}
                                // tslint:disable-next-line: jsx-no-lambda
                                onClose={() => this.setState({ showInstrumentRemeasureDialog: false })}
                                showCloseButton={true}
                                closeOnEscape={false}
                                closeOnLostFocus={false}
                                dimBackground={true}
                                title={t(CONSTANTS.SAMPLE_INSTRUMENT_REMEASURE_MSG)}
                                standardButtonsOnBottom={[
                                    { text: t(CONSTANTS.BUTTON_CANCEL), type: 'discreet-blue', handler: dlg => dlg.close() },
                                    { text: t(CONSTANTS.BUTTON_OK), type: 'primary-blue', handler: this.remeasureAfterConfirmation }
                                ]} />


                            <Dialog isOpen={this.state.showInstrumentStopDialog}
                                // tslint:disable-next-line: jsx-no-lambda
                                onClose={() => this.setState({ showInstrumentStopDialog: false })}
                                showCloseButton={true}
                                closeOnEscape={false}
                                closeOnLostFocus={false}
                                dimBackground={true}
                                title={t(CONSTANTS.SAMPLE_INSTRUMENT_STOPPED_MSG)}
                                standardButtonsOnBottom={[
                                    { text: t(CONSTANTS.BUTTON_CANCEL), type: 'discreet-blue', handler: dlg => dlg.close() },
                                    { text: t(CONSTANTS.BUTTON_OK), type: 'primary-blue', handler: this.stopAfterConfirm }
                                ]} />

                        </div>
                    </React.Fragment>
                )}
            </Translation>
        );
    }

}

export default withRouter(MeasurementLanding)